export const countries = [
  // Priority: India first
  {name: 'India', code: 'IN', dialCode: '+91'},

  // Gulf countries (key market)
  {name: 'Bahrain', code: 'BH', dialCode: '+973'},
  {name: 'Iraq', code: 'IQ', dialCode: '+964'},
  {name: 'Jordan', code: 'JO', dialCode: '+962'},
  {name: 'Kuwait', code: 'KW', dialCode: '+965'},
  {name: 'Lebanon', code: 'LB', dialCode: '+961'},
  {name: 'Oman', code: 'OM', dialCode: '+968'},
  {name: 'Qatar', code: 'QA', dialCode: '+974'},
  {name: 'Saudi Arabia', code: 'SA', dialCode: '+966'},
  {name: 'United Arab Emirates', code: 'AE', dialCode: '+971'},
  {name: 'Yemen', code: 'YE', dialCode: '+967'},

  // Rest of the world (alphabetical)
  {name: 'Afghanistan', code: 'AF', dialCode: '+93'},
  {name: 'Argentina', code: 'AR', dialCode: '+54'},
  {name: 'Australia', code: 'AU', dialCode: '+61'},
  {name: 'Bangladesh', code: 'BD', dialCode: '+880'},
  {name: 'Belgium', code: 'BE', dialCode: '+32'},
  {name: 'Brazil', code: 'BR', dialCode: '+55'},
  {name: 'Canada', code: 'CA', dialCode: '+1'},
  {name: 'China', code: 'CN', dialCode: '+86'},
  {name: 'Colombia', code: 'CO', dialCode: '+57'},
  {name: 'Egypt', code: 'EG', dialCode: '+20'},
  {name: 'Ethiopia', code: 'ET', dialCode: '+251'},
  {name: 'France', code: 'FR', dialCode: '+33'},
  {name: 'Germany', code: 'DE', dialCode: '+49'},
  {name: 'Ghana', code: 'GH', dialCode: '+233'},
  {name: 'Hong Kong', code: 'HK', dialCode: '+852'},
  {name: 'Indonesia', code: 'ID', dialCode: '+62'},
  {name: 'Iran', code: 'IR', dialCode: '+98'},
  {name: 'Ireland', code: 'IE', dialCode: '+353'},
  {name: 'Israel', code: 'IL', dialCode: '+972'},
  {name: 'Italy', code: 'IT', dialCode: '+39'},
  {name: 'Japan', code: 'JP', dialCode: '+81'},
  {name: 'Kenya', code: 'KE', dialCode: '+254'},
  {name: 'Malaysia', code: 'MY', dialCode: '+60'},
  {name: 'Maldives', code: 'MV', dialCode: '+960'},
  {name: 'Mexico', code: 'MX', dialCode: '+52'},
  {name: 'Morocco', code: 'MA', dialCode: '+212'},
  {name: 'Myanmar', code: 'MM', dialCode: '+95'},
  {name: 'Nepal', code: 'NP', dialCode: '+977'},
  {name: 'Netherlands', code: 'NL', dialCode: '+31'},
  {name: 'New Zealand', code: 'NZ', dialCode: '+64'},
  {name: 'Nigeria', code: 'NG', dialCode: '+234'},
  {name: 'Pakistan', code: 'PK', dialCode: '+92'},
  {name: 'Philippines', code: 'PH', dialCode: '+63'},
  {name: 'Poland', code: 'PL', dialCode: '+48'},
  {name: 'Portugal', code: 'PT', dialCode: '+351'},
  {name: 'Russia', code: 'RU', dialCode: '+7'},
  {name: 'Singapore', code: 'SG', dialCode: '+65'},
  {name: 'South Africa', code: 'ZA', dialCode: '+27'},
  {name: 'South Korea', code: 'KR', dialCode: '+82'},
  {name: 'Spain', code: 'ES', dialCode: '+34'},
  {name: 'Sri Lanka', code: 'LK', dialCode: '+94'},
  {name: 'Sweden', code: 'SE', dialCode: '+46'},
  {name: 'Switzerland', code: 'CH', dialCode: '+41'},
  {name: 'Thailand', code: 'TH', dialCode: '+66'},
  {name: 'Turkey', code: 'TR', dialCode: '+90'},
  {name: 'Uganda', code: 'UG', dialCode: '+256'},
  {name: 'United Kingdom', code: 'GB', dialCode: '+44'},
  {name: 'United States', code: 'US', dialCode: '+1'},
  {name: 'Vietnam', code: 'VN', dialCode: '+84'},
];
